import 'tailwindcss/tailwind.css';
import '@sendbird/uikit-react/dist/index.css';
import './global-style.css';
import { SWRConfig } from 'swr';

import { SteadioHead } from '@components/common/head';
import AccessControl from '@components/common/access-control/AccessControl';
import { ModalProvider, Modals } from '@components/common/modal';
import useInitBranch from '@hooks/branch';
import useInitAnalytics from '@hooks/analytics';
import { fetcher } from '@libraries/common/fetcher';

import type { AppProps } from 'next/app';

export default function MyApp({ Component, pageProps }: AppProps) {
  useInitBranch();
  useInitAnalytics();

  return (
    <SWRConfig value={{ fetcher }}>
      <ModalProvider>
        <AccessControl>
          <SteadioHead />
          <Component {...pageProps} />
          <Modals />
        </AccessControl>
      </ModalProvider>
    </SWRConfig>
  );
}
